/* eslint-disable  react/jsx-no-bind */
import React from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { capitalizeWords } from '~/utils/validateCharacters';
import ComponentSelector from './ComponentSelector';

function WidgetRender(props: any) {
  const { parentKey, widgets, sectionHeader, formName, index, selectedProducts, productLocked } = props;

  const { t } = useTranslation();
  const hideSectionHeader = sectionHeader === 'CONFIGURATION';

  return (
    <>
      {sectionHeader !== 'HIERARCHY_LEVELS' && (
        <>
          {!hideSectionHeader && (
            <Typography.Title level={5}>{capitalizeWords(t(sectionHeader))}</Typography.Title>
          )}
          <Space direction="vertical" size={0} style={{ width: '100%' }}>
            {widgets?.map((item: any) => (
              <ComponentSelector
                index={index}
                key={`${parentKey}.${sectionHeader}-${item?.key}`}
                parentKey={parentKey}
                sectionHeader={sectionHeader}
                item={item}
                formName={formName}
                selectedProducts={selectedProducts}
                productLocked={productLocked}
              />
            ))}
          </Space>
        </>
      )}
    </>
  );
}
export default WidgetRender;
